/**
 * documentsreducer.js
 * Created by calhosh on 9/9/2020.
 */
import {normalize} from '../../util/utils';
import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';

export function documentsReducer(state = initialstate.documents, action) {
	switch (action.type) {
		case types.GET_ALL_DOCUMENTS:
			if (action.response.data) {
				const documentsList = normalize(action.response.data, 'id', state, undefined, true);
				documentsList.pages = action.response.pages;
				documentsList.totalEntityCount = action.response.totalEntityCount;
				return documentsList;
			}

			return state;
		default:
			return state;
	}
}

export function setDocumentIdReducer(state = initialstate.documentId, action) {
	switch (action.type) {
		case types.SET_DOCUMENT_ID: {
			if (action.documentId) {
				return action.documentId;
			} else {
				return state;
			}
		}
		default:
			return state;
	}
}

export function setIsMFEReducer(state = initialstate.isMFE, action) {
	switch (action.type) {
		case types.SET_IS_MFE: {
			return action.isMFE;
		}
		default:
			return state;
	}
}
